const header = () => {
  // Non-touch devices only
  if (window.innerWidth > 1024) {
    document.querySelectorAll('.tl-header details').forEach(details => {
      details.addEventListener('mouseenter', () => {
        details.setAttribute('open', 'true');
        document.body.classList.add('menu-open');
      });
      details.addEventListener('mouseleave', () => {
        details.removeAttribute('open');
        document.body.classList.remove('menu-open');
      });
    });
  }

  const toggle = document.getElementById('tl-menu-toggle');
  if (toggle !== null) {
    toggle.addEventListener('click', () => {
      toggle.classList.toggle('open');
      document.body.classList.toggle('menu-open');
    });
  }
};

export default header;
